import { render, staticRenderFns } from "./Watermark.vue?vue&type=template&id=2d06bbf3&scoped=true"
import script from "./Watermark.vue?vue&type=script&lang=js"
export * from "./Watermark.vue?vue&type=script&lang=js"
import style0 from "./Watermark.vue?vue&type=style&index=0&id=2d06bbf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06bbf3",
  null
  
)

export default component.exports